export default [
  'Aly',
  'Anx',
  'Arc',
  'Ave',
  'Bch',
  'Bg',
  'Bgs',
  'Blf',
  'Blfs',
  'Blvd',
  'Bnd',
  'Br',
  'Brdge',
  'Brg',
  'Brk',
  'Brks',
  'Btm',
  'Byp',
  'Byu',
  'Cir',
  'Cirs',
  'Clb',
  'Clf',
  'Clfs',
  'Cmn',
  'Cmns',
  'Cor',
  'Cors',
  'Cp',
  'Cpe',
  'Cres',
  'Crk',
  'Crse',
  'Crst',
  'Cswy',
  'Ct',
  'Ctr',
  'Ctrs',
  'Cts',
  'Curv',
  'Cv',
  'Cvs',
  'Cyn',
  'Dl',
  'Dm',
  'Dr',
  'Drs',
  'Dv',
  'Est',
  'Ests',
  'Expy',
  'Ext',
  'Exts',
  'Fall',
  'Fld',
  'Flds',
  'Fls',
  'Flt',
  'Flts',
  'Frd',
  'Frds',
  'Frg',
  'Frgs',
  'Frk',
  'Frks',
  'Frst',
  'Fry',
  'Ft',
  'Fwy',
  'Gdn',
  'Gdns',
  'Gln',
  'Glns',
  'Grn',
  'Grns',
  'Grv',
  'Grvs',
  'Gtwy',
  'Hbr',
  'Hbrs',
  'Hl',
  'Hls',
  'Holw',
  'Hts',
  'Hvn',
  'Hwy',
  'Inlt',
  'Is',
  'Isle',
  'Iss',
  'Jct',
  'Jcts',
  'Knl',
  'Knls',
  'Ky',
  'Kys',
  'Land',
  'Lck',
  'Lcks',
  'Ldg',
  'Lf',
  'Lgt',
  'Lgts',
  'Lk',
  'Lks',
  'Ln',
  'Lndg',
  'Loop',
  'Mall',
  'Mdw',
  'Mdws',
  'Mews',
  'Ml',
  'Mls',
  'Mnr',
  'Mnrs',
  'Msn',
  'Mt',
  'Mtn',
  'Mtns',
  'Mtwy',
  'Nck',
  'Opas',
  'Orch',
  'Oval',
  'Park',
  'Pass',
  'Path',
  'Pike',
  'Pine',
  'Pkwy',
  'Pl',
  'Pln',
  'Plns',
  'Plz',
  'Pne',
  'Pnes',
  'Pr',
  'Prt',
  'Prts',
  'Psge',
  'Pt',
  'Pts',
  'Radl',
  'Ramp',
  'Rd',
  'Rdg',
  'Rdgs',
  'Rds',
  'Riv',
  'Rnch',
  'Row',
  'Rpd',
  'Rpds',
  'Rst',
  'Rte',
  'Rue',
  'Run',
  'Shl',
  'Shls',
  'Shr',
  'Shrs',
  'Skwy',
  'Smt',
  'Spg',
  'Spgs',
  'Spur',
  'Sq',
  'Sqs',
  'St',
  'Sta',
  'Stra',
  'Strm',
  'Sts',
  'Ter',
  'Tpke',
  'Trak',
  'Trce',
  'Trfy',
  'Trl',
  'Trlr',
  'Trwy',
  'Tunl',
  'Un',
  'Uns',
  'Upas',
  'Via',
  'Vis',
  'Vl',
  'Vlg',
  'Vlgs',
  'Vly',
  'Vlys',
  'Vw',
  'Vws',
  'Walk',
  'Wall',
  'Way',
  'Ways',
  'Wl',
  'Wls',
  'Xing',
  'Xrd',
  'Xrds',
];
